import React, { useState, useEffect } from "react";
import { pb } from "../services/pocketbase";
import {
  BarChart2,
  ClipboardList,
  Barcode,
  Bookmark,
  Factory,
  Truck,
  ArrowUp,
  Boxes,
  Upload,
  Clipboard,
  Archive,
  Settings,
  ArrowRight,
  Database,
  Package,
  Wrench,
  Sparkles,
  Bike,
  Activity,
  Sliders,
  Calculator,
  Plus,
  ShoppingBag,
  Award,
  GraduationCap
} from "lucide-react";
import { TAB_LABELS, GROUPS } from "../components/layout/Sidebar";


const TAB_ICONS = {
  dashboard: BarChart2,
  stock: ClipboardList,
  supplies: Package,
  conference: Barcode,
  reservations: Bookmark,
  production: Factory,
  orders: Truck,
  transit: ArrowUp,
  stock_production: Boxes,
  sales: Upload,
  reports: Clipboard,
  archived: Archive,
  config: Settings,
  oficina: Wrench,
  novos_produtos: Sparkles,
  motoboy: Bike,
  pdv: ShoppingBag,
  pontuacao: Award,
  treinamentos: GraduationCap,
};

const TAB_DESCRIPTIONS = {
  dashboard: "Visão geral e faturamento atualizado.",
  stock: "Tabela Mestre Física e visualização geral de saldos.",
  supplies: "Gestão física, receitas BOM e compras de insumos.",
  conference: "Entrada via bipe/leitor de novos produtos.",
  reservations: "Painel de controle de itens aguardando faturamento.",
  production: "Kanban de acompanhamento para fabricação de joias.",
  orders: "Gestão logística e empacotamento das encomendas prontas.",
  transit: "Peças em transito entre Escritorio e Estoque.",
  stock_production: "Controle e baixa de matérias de base bruta da fábrica.",
  sales: "Vendas diretas e dação de peças (Baixa Rápida).",
  reports: "Gráficos de fluxo e Logs das tabelas de auditoria.",
  archived: "Reservas concluídas/histórico da operação.",
  config: "Sincronização de catálogos e reset de base admin.",
  oficina: "Calculadora de ligas, gesso, rampa, banho e manutenção de máquinas.",
  novos_produtos: "Desenvolvimento de novos modelos, fichas técnicas e precificação.",
  motoboy: "Roteirização de entregas, recibos digitais e acerto de contas.",
  pdv: "Frente de caixa ágil para vendas presenciais no showroom.",
  pontuacao: "Histórico de pontos e dashboard de bônus individual.",
  treinamentos: "Manuais operacionais, POPs de fábrica e atendimento.",
};

const TAB_COLORS = {
  dashboard: "bg-blue-500",
  stock: "bg-emerald-500",
  supplies: "bg-sky-600",
  conference: "bg-teal-500",
  reservations: "bg-indigo-500",
  production: "bg-orange-500",
  orders: "bg-pink-500",
  transit: "bg-amber-600",
  stock_production: "bg-violet-500",
  sales: "bg-red-500",
  reports: "bg-slate-500",
  archived: "bg-slate-700",
  config: "bg-slate-850",
  oficina: "bg-amber-500",
  novos_produtos: "bg-purple-500",
  motoboy: "bg-cyan-600",
  pdv: "bg-blue-600",
  pontuacao: "bg-amber-500",
  treinamentos: "bg-indigo-600",
};

const GROUP_ICONS = {
  operacoes: Activity,
  estoque: Boxes,
  criacao: Sparkles,
  gestao: BarChart2,
  sistema: Sliders
};

const GROUP_THEMES = {
  operacoes: {
    text: "text-blue-600",
    bg: "bg-blue-50/70",
    badge: "bg-blue-50 text-blue-700 border-blue-100",
    hoverBorder: "hover:border-blue-300 hover:shadow-blue-50/20"
  },
  estoque: {
    text: "text-emerald-600",
    bg: "bg-emerald-50/70",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-100",
    hoverBorder: "hover:border-emerald-300 hover:shadow-emerald-50/20"
  },
  criacao: {
    text: "text-purple-600",
    bg: "bg-purple-50/70",
    badge: "bg-purple-50 text-purple-700 border-purple-100",
    hoverBorder: "hover:border-purple-300 hover:shadow-purple-50/20"
  },
  gestao: {
    text: "text-amber-600",
    bg: "bg-amber-50/70",
    badge: "bg-amber-50 text-amber-700 border-amber-100",
    hoverBorder: "hover:border-amber-300 hover:shadow-amber-50/20"
  },
  sistema: {
    text: "text-slate-600",
    bg: "bg-slate-100",
    badge: "bg-slate-100 text-slate-700 border-slate-200",
    hoverBorder: "hover:border-slate-350 hover:shadow-slate-50/20"
  }
};


export default function HomeTab({ hasAccess, setActiveTab, user, loadingCatalog }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form, setForm] = useState({
    sku: "",
    nome_produto: "",
    tipo_joia: "Anel",
    categoria: "Formatura",
    modelo: "",
    prioridade: "media",
    observacoes: ""
  });
  const [saving, setSaving] = useState(false);


  const handleSaveModeling = async (e) => {
    e.preventDefault();
    if (!form.nome_produto.trim()) return alert("Digite o nome do produto.");

    setSaving(true);
    try {
      const protoSku = "PRT-" + Math.floor(100000 + Math.random() * 900000);
      const formDataObj = new FormData();
      formDataObj.append("sku", protoSku);
      formDataObj.append("nome_produto", form.nome_produto.trim());
      formDataObj.append("tipo_joia", form.tipo_joia);
      formDataObj.append("categoria", form.categoria);
      formDataObj.append("modelo", form.modelo.trim());
      formDataObj.append("status", "pendente_aprovacao");
      formDataObj.append("responsavel", user?.id || "");
      formDataObj.append("prioridade", form.prioridade);
      formDataObj.append("observacoes", form.observacoes.trim());

      await pb.collection("modelagens").create(formDataObj);
      setIsModalOpen(false);
      alert("Solicitação de modelagem criada com sucesso!");
    } catch (err) {
      alert("Erro ao criar solicitação: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  const visibleTabs = Object.keys(TAB_LABELS).filter(tab => {
    if (tab === "colaboradores" || tab === "treinamentos") return true;
    if (tab === "pontuacao") return hasAccess("pontuacao");
    if (!hasAccess(tab)) {
      if (tab === "transit" && (hasAccess("production") || hasAccess("orders"))) return true;
      if (tab === "postagem" && (hasAccess("production") || hasAccess("orders"))) return true;
      if (tab === "dashboard" && user?.role === "master") return true;
      return false;
    }
    if (tab === "dashboard" && user?.role !== "master" && !hasAccess("dashboard")) return false;
    return true;
  });

  const allGroups = [
    ...GROUPS,
    { id: "sistema", label: "Sistema", color: "#64748B", tabs: ["config"] }
  ];

  const groupedTabs = allGroups.map(group => {
    const tabs = [];
    
    group.tabs.forEach(tabId => {
      if (visibleTabs.includes(tabId)) {
        tabs.push({
          id: tabId,
          title: TAB_LABELS[tabId],
          desc: TAB_DESCRIPTIONS[tabId],
          icon: TAB_ICONS[tabId] || ClipboardList,
          colorClass: TAB_COLORS[tabId] || "bg-slate-500",
          isShortcut: false
        });
        
        // Inject shortcuts right after the parent module card
        if (tabId === "novos_produtos") {
          tabs.push({
            id: "calculadora_avulsa",
            title: "Calculadora Avulsa",
            desc: "Cálculo rápido de orçamento e cotação de metais para novas joias.",
            icon: Calculator,
            colorClass: "bg-purple-500",
            isShortcut: true
          });
          tabs.push({
            id: "solicitar_modelagem",
            title: "Solicitar Modelagem",
            desc: "Solicitar novo modelo CAD 3D para criação de joias.",
            icon: Plus,
            colorClass: "bg-purple-500",
            isShortcut: true
          });
        }
        
        if (tabId === "supplies") {
          tabs.push({
            id: "modo_conferencia",
            title: "Modo Conferência",
            desc: "Conferência de insumos (bipes e conferência física).",
            icon: Barcode,
            colorClass: "bg-teal-500",
            isShortcut: true
          });
          tabs.push({
            id: "estoque_pedras",
            title: "Estoque de Pedras",
            desc: "Visualização e controle de estoque de zircônias e pedras.",
            icon: Sparkles,
            colorClass: "bg-purple-500",
            isShortcut: true
          });
        }
      }
    });

    return {
      ...group,
      tabs
    };
  }).filter(group => group.tabs.length > 0);

  const handleCardClick = (item) => {
    if (item.isShortcut) {
      if (item.id === "calculadora_avulsa") {
        localStorage.setItem("novos_produtos_active_subtab", "calc_avulsa");
        setActiveTab("novos_produtos");
      } else if (item.id === "solicitar_modelagem") {
        setForm({
          sku: "",
          nome_produto: "",
          tipo_joia: "Anel",
          categoria: "Formatura",
          modelo: "",
          prioridade: "media",
          observacoes: ""
        });
        setIsModalOpen(true);
      } else if (item.id === "modo_conferencia") {
        localStorage.setItem("supplies_active_subtab", "conference");
        setActiveTab("supplies");
      } else if (item.id === "estoque_pedras") {
        localStorage.setItem("supplies_active_subtab", "zirconias");
        setActiveTab("supplies");
      }
    } else {
      setActiveTab(item.id);
    }
  };

  return (
    <div className="w-full h-full p-4 md:p-8 overflow-y-auto custom-scrollbar animate-fade-in">
      <div className="max-w-6xl mx-auto">
        
        {/* Header de Boas Vindas */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6">
          <div>
            <h1 className="text-3xl font-extrabold text-slate-800 tracking-tight">Fala, {user?.name?.split(" ")[0]} 👋</h1>
            <p className="text-slate-500 mt-1 text-sm md:text-base">Bem-vindo(a) ao Sistema Gestão Sempre Joias. O que vamos fazer agora?</p>
          </div>
          
          {loadingCatalog ? (
            <div className="flex items-center gap-2 bg-blue-50 border border-blue-100 px-4 py-2 rounded-full shadow-sm pr-6">
              <div className="w-4 h-4 rounded-full border-2 border-blue-500 border-t-transparent animate-spin shrink-0"></div>
              <span className="text-xs font-bold text-blue-700">Sincronizando Catálogo...</span>
            </div>
          ) : (
            <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-100 px-4 py-2 rounded-full shadow-sm pr-6">
              <Database size={16} className="text-emerald-500 shrink-0" />
              <span className="text-xs font-bold text-emerald-700">Catálogo Atualizado</span>
            </div>
          )}
        </div>


        {/* Módulos Agrupados */}
        <div className="space-y-8">
          {groupedTabs.map((group) => {
            const theme = GROUP_THEMES[group.id] || GROUP_THEMES.sistema;
            const GroupIcon = GROUP_ICONS[group.id] || Sliders;
            
            return (
              <div key={group.id} className="animate-fade-in-up">
                {/* Cabeçalho do Grupo */}
                <div className="flex items-center gap-3 mb-4 pb-2 border-b border-slate-100">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${theme.text} ${theme.bg}`}>
                    <GroupIcon size={18} />
                  </div>
                  <div className="flex items-center gap-2">
                    <h2 className="text-sm font-bold text-slate-800 tracking-wider uppercase">
                      {group.label}
                    </h2>
                    <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border ${theme.badge}`}>
                      {group.tabs.length} {group.tabs.length === 1 ? "módulo" : "módulos"}
                    </span>
                  </div>
                </div>

                {/* Grade de Cards do Grupo - Reduzida e Compacta */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                  {group.tabs.map((tab) => {
                    const Icon = tab.icon;
                    const Title = tab.title;
                    const Desc = tab.desc;
                    const ColorClass = tab.colorClass;
                    
                    return (
                      <div 
                        key={tab.id}
                        onClick={() => handleCardClick(tab)}
                        className={`group bg-white border border-slate-200/80 rounded-xl p-3.5 shadow-sm hover:shadow-lg ${theme.hoverBorder} transition-all duration-300 cursor-pointer flex flex-col h-full relative overflow-hidden`}
                      >
                        {/* Background Decorativo Invisível no Hover */}
                        <div className={`absolute -right-12 -top-12 w-32 h-32 rounded-full opacity-0 group-hover:opacity-5 transition-opacity duration-300 ${ColorClass}`}></div>
                        
                        {/* Indicador lateral sutil da cor */}
                        <div className={`absolute left-0 top-0 bottom-0 w-1 ${ColorClass}`}></div>
                        
                        <div className="pl-1 flex flex-col h-full">
                          <div className="flex items-start justify-between mb-2.5">
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-white shadow-sm ${ColorClass}`}>
                              <Icon size={16} />
                            </div>
                            
                            {/* Crachá de Atalho */}
                            {tab.isShortcut && (
                              <span className="text-[8px] font-black uppercase px-1.5 py-0.5 rounded bg-slate-100 text-slate-500 border border-slate-200 tracking-wider shrink-0">
                                Atalho
                              </span>
                            )}
                          </div>
                          
                          <h3 className="font-bold text-slate-800 text-xs mb-1 group-hover:text-blue-700 transition-colors uppercase tracking-tight leading-snug">
                            {Title}
                          </h3>
                          <p className="text-slate-500 text-[10px] leading-snug flex-1">
                            {Desc}
                          </p>
                          
                          <div className="mt-3.5 flex items-center gap-1 text-[10px] font-bold text-blue-600 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all">
                            {tab.isShortcut ? "Ir para Atalho" : "Acessar Módulo"} <ArrowRight size={10} />
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>

      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[70] flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl border border-slate-200 flex flex-col max-h-[85vh] animate-scale-up text-left">
            <div className="p-5 border-b border-slate-100 flex justify-between items-center shrink-0">
              <h3 className="text-sm font-bold text-slate-800">
                Nova Solicitação de Modelagem
              </h3>
              <button onClick={() => setIsModalOpen(false)} className="text-slate-400 hover:text-slate-600 font-bold">✕</button>
            </div>

            <form onSubmit={handleSaveModeling} className="flex-1 overflow-y-auto custom-scrollbar p-6 space-y-4 font-bold text-xs">

              <div>
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Nome do Produto *</label>
                <input
                  type="text" required
                  value={form.nome_produto}
                  onChange={(e) => setForm({ ...form, nome_produto: e.target.value })}
                  placeholder="Ex: Anel Trindade Ouro"
                  className="w-full p-2.5 border border-slate-300 rounded-lg outline-none focus:ring-1 focus:ring-blue-500 text-xs"
                />
              </div>

              <div className="grid gap-4 grid-cols-3">
                <div>
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Tipo de Joia</label>
                  <select
                    value={form.tipo_joia}
                    onChange={(e) => setForm({ ...form, tipo_joia: e.target.value })}
                    className="w-full p-2.5 border border-slate-300 rounded-lg bg-white outline-none focus:ring-1 focus:ring-blue-500 text-xs font-bold"
                  >
                    <option value="Anel">Anel</option>
                    <option value="Brinco">Brinco</option>
                    <option value="Colar">Colar</option>
                    <option value="Pulseira">Pulseira</option>
                    <option value="Pingente">Pingente</option>
                    <option value="Tornozeleira">Tornozeleira</option>
                    <option value="Outro">Outro</option>
                  </select>
                </div>

                <div>
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Categoria</label>
                  <select
                    value={form.categoria}
                    onChange={(e) => setForm({ ...form, categoria: e.target.value })}
                    className="w-full p-2.5 border border-slate-300 rounded-lg bg-white outline-none focus:ring-1 focus:ring-blue-500 text-xs font-bold"
                  >
                    <option value="Formatura">Formatura</option>
                    <option value="Pet">Pet</option>
                    <option value="Coleção">Coleção</option>
                    <option value="Sacro">Sacro</option>
                    <option value="Espiritualista">Espiritualista</option>
                    <option value="Outros">Outros</option>
                  </select>
                </div>

                <div>
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Prioridade</label>
                  <select
                    value={form.prioridade}
                    onChange={(e) => setForm({ ...form, prioridade: e.target.value })}
                    className="w-full p-2.5 border border-slate-300 rounded-lg bg-white outline-none focus:ring-1 focus:ring-blue-500 text-xs font-bold"
                  >
                    <option value="urgente">Urgente</option>
                    <option value="alta">Alta</option>
                    <option value="media">Média</option>
                    <option value="baixa">Baixa</option>
                  </select>
                </div>
              </div>

              <div className="grid gap-4 grid-cols-2">
                <div>
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Modelo</label>
                  <input
                    type="text"
                    value={form.modelo}
                    onChange={(e) => setForm({ ...form, modelo: e.target.value })}
                    placeholder="Ex: Escapulário, Solitário"
                    className="w-full p-2.5 border border-slate-300 rounded-lg outline-none focus:ring-1 focus:ring-blue-500 text-xs font-bold"
                  />
                </div>

                <div>
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Responsável / Designer</label>
                  <input
                    type="text"
                    disabled
                    value={user?.name || ""}
                    className="w-full p-2.5 border border-slate-200 rounded-lg bg-slate-50 text-slate-500 outline-none text-xs font-bold select-none"
                  />
                </div>
              </div>

              <div>
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1">Instruções / Observações</label>
                <textarea
                  value={form.observacoes}
                  onChange={(e) => setForm({ ...form, observacoes: e.target.value })}
                  rows={3}
                  placeholder="Informações adicionais de pedras, peso estimado ou detalhes..."
                  className="w-full p-2.5 border border-slate-300 rounded-lg outline-none focus:ring-1 focus:ring-blue-500 font-semibold text-xs"
                />
              </div>

              <div className="pt-4 border-t border-slate-100 flex justify-end gap-2 shrink-0">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 text-xs font-bold text-slate-500 hover:bg-slate-100 rounded-lg"
                  disabled={saving}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg text-xs shadow-sm flex items-center gap-1.5"
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <div className="w-3.5 h-3.5 rounded-full border-2 border-white border-t-transparent animate-spin"></div>
                      Criando...
                    </>
                  ) : (
                    "Salvar Solicitação"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
